import type { Pathnames } from "next-intl/routing";

import type { Locale } from "@/services/i18n";

export const pathnames = {
  "/": "/",
  "/membership": {
    pl: "/membership",
  },
  "/membership/thank-you": {
    pl: "/membership/dziekujemy",
  },
  "/terms-and-conditions": {
    pl: "/regulamin",
  },
  "/contact": {
    pl: "/kontakt",
  },
  "/blood-test/[slug]": {
    pl: "/new-badanie/[slug]",
  },
  "/blood-tests-package/[slug]": {
    pl: "/new-pakiet/[slug]",
  },
  "/blood-tests-package-legacy/[slug]": {
    pl: "/pakiet/[slug]",
  },
  "/blood-test-legacy/[slug]": {
    pl: "/badanie/[slug]",
  },
  "/blog": {
    pl: "/poradnik",
  },
  "/blog/[slug]": {
    pl: "/poradnik/[slug]",
  },
  "/blog-draft": {
    pl: "/poradnik-draft",
  },
  "/blog-draft/[slug]": {
    pl: "/poradnik-draft/[slug]",
  },
  "/refer-a-friend/[slug]": {
    pl: "/system-polecen/[slug]",
  },
  "/refer-a-friend/link-expired": {
    pl: "/system-polecen/link-wygasl",
  },
  "/consultations-online/[slug]": {
    pl: "/konsultacje-online/[slug]",
  },
  "/consultations-online/[slug]/thank-you": {
    pl: "/konsultacje-online/[slug]/dziekujemy",
  },
  "/b2b": {
    pl: "/akcjazdrowia",
  },
  "/recruitment": {
    pl: "/rekrutacja",
  },
  "/about-us": {
    pl: "/o-nas",
  },
  "/home-blood-tests": {
    pl: "/domowe-badania-krwi",
  },
  "/promo-100": {
    pl: "/badania-w-domu-100-zl-taniej",
  },
  "/promo-20": {
    pl: "/pobranie-krwi-w-domu-20",
  },
  "/tests-categories": {
    pl: "/kategorie-badan",
  },
  "/referral-system": {
    pl: "/system-polecen",
  },
  "/consultations": {
    pl: "/konsultacje-online",
  },
  "/hrano": {
    pl: "/hrano",
  },
  "/city/[slug]": {
    pl: "/badania-krwi/[slug]",
  },
  "/where-we-operate": {
    pl: "/gdzie-dzialamy",
  },
  "/ordering": {
    pl: "/zamowienie-v2",
  },
  "/ordering/catalog": {
    pl: "/zamowienie-v2/katalog-badan",
  },
  "/ordering/test": {
    pl: "/zamowienie-v2/test",
  },
} as const satisfies Pathnames<typeof Locale.schema.options>;
